import { Box, useTheme } from "@mui/material";
import React from "react";
import { SxProps, Theme } from "@mui/system";

interface TypographyProps {
  variant:
    | "heading1"
    | "heading2"
    | "heading3"
    | "heading4"
    | "heading5"
    | "heading6"
    | "heading7"
    | "heading8"
    | "heading9"
    | "body1"
    | "body2"
    | "body3"
    | "body4"
    | "body5"
    | "body6"
    | "body7"
    | "body8"
    | "caption";
  children: React.ReactNode;
  style?: React.CSSProperties;
  color?: string;
  className?: string;
  fontWeight?: number;
  sx?: SxProps<Theme>;
  title?: string;
  onClick?: () => void;
}
const CustomTypography: React.FC<TypographyProps> = ({
  variant,
  children,
  style,
  color,
  fontWeight,
  className = "",
  sx,
  title,
  onClick,
}) => {
  const theme = useTheme();
  const defaultColor = color
    ? color
    : theme.palette.mode === "dark"
      ? "#FFFFFF"
      : theme.palette.text.primary;
  const baseStyles: Record<string, React.CSSProperties> = {
    heading1: {
      fontSize: "1.8rem",
      fontWeight: fontWeight || 700,
      lineHeight: "1.2",
    },
    heading2: {
      fontSize: "1.6rem",
      fontWeight: fontWeight || 700,
      lineHeight: "1.2",
    },
    heading3: {
      fontSize: "1.4rem",
      fontWeight: fontWeight || 700,
      lineHeight: "1.2",
    },
    heading4: {
      fontSize: "1.2rem",
      fontWeight: fontWeight || 700,
      lineHeight: "1.2",
    },
    heading5: {
      fontSize: "1.1rem",
      fontWeight: fontWeight || 700,
      lineHeight: "1.2",
    },
    heading6: {
      fontSize: "1rem",
      fontWeight: fontWeight || 600,
      lineHeight: "1.1",
    },
    heading7: {
      fontSize: "0.9rem",
      fontWeight: fontWeight || 600,
      lineHeight: "1.1",
    },
    heading8: {
      fontSize: "0.8rem",
      fontWeight: fontWeight || 600,
      lineHeight: "1.1",
    },
    heading9: {
      fontSize: "0.7rem",
      fontWeight: fontWeight || 600,
      lineHeight: "1.1",
    },
    body1: { fontSize: "0.9rem", fontWeight: fontWeight, lineHeight: "1.3" },
    body2: { fontSize: "0.8rem", fontWeight: fontWeight, lineHeight: "1.3" },
    body3: { fontSize: "0.7rem", fontWeight: fontWeight, lineHeight: "1.3" },
    body4: { fontSize: "0.6rem", fontWeight: fontWeight, lineHeight: "1.3" },
    body5: { fontSize: "0.5rem", fontWeight: fontWeight, lineHeight: "1.3" },
    body6: { fontSize: "0.4rem", fontWeight: fontWeight, lineHeight: "1.3" },
    body7: { fontSize: "0.3rem", fontWeight: fontWeight, lineHeight: "1.3" },
    body8: { fontSize: "0.1rem", fontWeight: fontWeight, lineHeight: "1.3" },
    caption: { fontSize: "0.7rem", fontWeight: fontWeight, lineHeight: "1.3" },
  };
  return (
    <Box
      style={{
        ...baseStyles[variant || "body1"],
        color: defaultColor,
        alignContent: "center",
        ...style,
      }}
      className={className}
      {...(sx as any)}
      title={title}
      onClick={onClick}
    >
      {children}
    </Box>
  );
};
export default CustomTypography;
